module.exports = __webpack_public_path__ + "img/facetime.18a2b099.png";